import { useTranslation } from 'react-i18next';
import { PanelSection, Textarea } from '@/shared/ui';
import { SegmentedField, TextField } from '@/shared/forms';
import { FORM_LABEL_WIDTH } from '../../../formLayout';
import { TRANSPORT_TYPE_OPTIONS } from '../serieFormSchema';
import type { SerieFormApi } from '../useSerieForm';

interface SerieFormFieldsProps {
  form: SerieFormApi;
}

/**
 * Sdílená sada polí pro založení série (Název série, Typ dopravy, Interní poznámka). Odpovědné osoby
 * jsou samostatný panel (`ResponsiblePersonsPanel`), skládaný v konkrétním formuláři. Používá ji jak
 * formulář série, tak formulář produktu (ten navíc nad ní renderuje Název produktu).
 */
export function SerieFormFields({ form }: SerieFormFieldsProps) {
  const { t } = useTranslation('venua-planner');

  return (
    <>
      <PanelSection>
        <form.Field name="name">
          {(field) => (
            <TextField
              field={field}
              label={t('serie.name.label')}
              required
              layout="inline"
              labelWidth={FORM_LABEL_WIDTH}
              placeholder={t('serie.name.placeholder')}
              data-testid="serie-name-input"
            />
          )}
        </form.Field>

        <form.Field name="transportType">
          {(field) => (
            <SegmentedField
              field={field}
              label={t('serie.transport.sectionLabel')}
              labelWidth={FORM_LABEL_WIDTH}
              helperText={t('serie.transport.help')}
              options={TRANSPORT_TYPE_OPTIONS.map((option) => ({
                value: option,
                label: t(`serie.transport.${option}`),
              }))}
              testId="serie-transport-type"
            />
          )}
        </form.Field>
      </PanelSection>

      <PanelSection title={t('serie.note.sectionLabel')}>
        <form.Field name="note">
          {(field) => (
            <Textarea
              rows={5}
              value={field.state.value}
              onChange={(event) => field.handleChange(event.target.value)}
              placeholder={t('serie.note.placeholder')}
              data-testid="serie-note-input"
            />
          )}
        </form.Field>
      </PanelSection>
    </>
  );
}
